import React from "react";
import "./BottomBar.scss";

export default props => (
  <footer {...props} className="footer">
    <span className="copyright">Copyright &copy; Linia i Forma 2018</span>
  </footer>
);
